import { Params } from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Http, URLSearchParams } from "@angular/http";
import { AccessToken as MyAccessToken } from "@app/util/accessToken";
import { MixpanelEventLoggingService } from "@app/shared/services/mixpanel-event-logging.service";
import { BehaviorSubject, Observable } from "rxjs";
@Injectable()
export class RolesSharedService {
  private params = new URLSearchParams();
  public filterData =  [];
  accessToken: string;
  private isPaymentCompleted = false;
  public globalSearchResponse = new BehaviorSubject<{}>({});
  public masterSearchFilter = new BehaviorSubject<{}>({
    search: '',
    type: '',
    limit : 10,
    skip: 0
  });
  public searchResponse: Observable<any>;
  public searchFilter: Observable<any>;

  constructor(private httpClient: HttpClient, private http: Http,
    private myAccessToken: MyAccessToken,
    private mixpanelEventLoggingService: MixpanelEventLoggingService) {
      this.searchResponse = this.globalSearchResponse.asObservable();
      this.searchFilter = this.masterSearchFilter.asObservable();
     }


  setFilterData(filterKey: string , filterValue: any) {
    this.filterData[filterKey] = filterValue;
  }

  getFilterData(filterKey: string) {
    return this.filterData[filterKey];
  }

  getUserId() {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      return JSON.parse(window.sessionStorage.getItem("userDetails")).userId;
    }
  }

  getLikesData(id , skip?:any , limit?:any) {
    const filter: any = {};
    if (skip) {
      filter.skip = skip;
    }
    if (limit) {
      filter.limit = limit;
    }
    return this.httpClient.get(`Likes/${id}/users`, {
      params: filter
    });
}

  getDashboardCounts(userId) {
    return this.httpClient.get(`users/${userId}/dashboard`);
  }

  getResearchData(filter, researchId) {
    return this.httpClient.get(`ResearchDocuments/${researchId}`, {
      params: filter
    });
  }

  getTrendingResearches(filter: any) {
    return this.httpClient.get("TrendingResearches/getList", {
      params: filter
    });
  }
  // trending research new api for dashboard
  getTrendingResearchView(filter:any){
    return this.httpClient.get(`TrendingResearchViews/getList`,{
      params: filter
    });
  }

  getBlogs(filter: any) {
    return this.httpClient.get("users/blogs", { params: filter });
  }

  getAllResearches(filter: any) {
    return this.httpClient.get("ResearchDocuments/getList", {
      params: filter
    });
  }

  getAllCount() {
    return this.httpClient.get("ResearchDocuments/count");
  }

  getPublicIp() {
    return this.http.get("https://api.ipify.org/?format=json");
  }

  contactUsData(contactData: any) {
    return this.httpClient.post("ContactUs", contactData);
  }

  getFutureResearch(filter: any) {
    return this.httpClient.get("UpcomingResearches/list", { params: filter });
    // return this.httpClient.get("UpcomingResearches", { params: filter });
  }

  getEcosystmTV(filter: any) {
    return this.httpClient.get('users/ecostsmtv', { params: filter });
  }

  getEcosystmTVHomepage(filter: any) {
    return this.httpClient.get('users/ecostsmtvhomepage', { params: filter });
  }

  getComments(filter: any) {
    let endpointUrl = '';
    if (filter.parentCommentId) {
      endpointUrl = `Comments/list?postId=${filter.postId}&limit=${filter.limit}
      &skip=${filter.skip}&parentCommentId=${filter.parentCommentId}`;
    } else {
      endpointUrl = `Comments/list?postId=${filter.postId}&limit=${filter.limit}
      &skip=${filter.skip}`;
    }
    return this.httpClient.get(endpointUrl);
  }

  logLikeInMixpanel(type , name) {
    this.mixpanelEventLoggingService.dispatchEvent("like", {
      "Item Type": type ? type : '',
      "Item Name": name ? name : '',
    });
  }

  getMoreComments(filter: object) {
    const params: HttpParams = new HttpParams().set(
      "filter",
      JSON.stringify(filter)
    );
    return this.httpClient.get("Comments", { params: params });
  }

  addLike(params: any) {
    return this.httpClient.post("Likes/post-like", params);
  }

  addComment(commentObject: Object) {
    return this.httpClient.post("Comments", JSON.stringify(commentObject));
  }
  viewReport(viewDetails: Object) {
    return this.httpClient.post("UserAnalystActivities/activity", viewDetails);
  }
  // getAnalystList(filter: object) {
  //   const params: HttpParams = new HttpParams()
  //     .set("roleCode", filter["roleCode"])
  //     .append("limit", JSON.stringify(filter["limit"]))
  //     .append("skip", JSON.stringify(filter["skip"]));
  //   return this.httpClient.get("users/list-by-role", { params: params });
  // }

  getAnalystList(filter: any) {
    return this.httpClient.get("UserRoleViews", { params: filter });
  }

  getAnalystListDetails(filter: any) {
    return this.httpClient.get("AnalystDetailViews/analyst-detail", { params: filter });
  }

  getNewAnalystListDetails(filter: any) {
    return this.httpClient.get("AnalystDetailViews/analyst-detail-new", { params: filter });
  }

  analystFollow(filter: any) {
    return this.httpClient.post("AnalystFollowers/follow", filter);
  }

  getTechDomainsList(isParent?: boolean, parentDomainId?: any) {

    let filter: any = {};
    if (isParent) {
      filter = { where: { isParent: true } };
    }
    if (parentDomainId) {
      filter = { where: { parentDomainId: parentDomainId } };
    }
    return this.httpClient.get("TechDomains", {
      params: { filter: JSON.stringify(filter) }
    });
  }

  getTechDomainsGetList(search?: any, order?: any , limit?: any, skip?: any) {
    let filter: any = {};
    if (search) {
      filter.search = search;
    }
    if (order) {
      filter.order = order;
    }
    if (limit) {
      filter.limit = limit;
    }
    if (skip) {
      filter.skip = skip;
    }
    return this.httpClient.get("TechDomains/getList", {
      params:  filter
    });
  }

  getTopicsList(domainId: any) {
    const filter: any = {};
    filter.domainId = domainId;
    filter.sort = "ASC";
    return this.httpClient.get(`Topics/get-list`,{
      params: filter
    });
  }

  getFiltersByTopic(topicId: any , forFilter: boolean) {
    return this.httpClient.get(`VendorAssessmentTools/details?topicId=${topicId}&forFilter=${forFilter}`);
  }

  getIndustryFilters() {
    return this.httpClient.get(`Industries/getList`);
  }

  getItBudgetFilters() {
    const filter: any = {};
    filter.sort = "ASC";
    return this.httpClient.get(`ItBudgets/getList`,{
      params: filter
    });
  }

  getGeographyFilters() {
    return this.httpClient.get(`Geographies/getList`);
  }

  lineOfBusinessFilters() {
    return this.httpClient.get(`LineOfBusinesses/getList`);
  }

  countryFilters() {
    return this.httpClient.get(`Countries/getList`);
  }

  employeeSizeFilters() {
    const filter: any = {};
    filter.order = "sequence ASC";
    return this.httpClient.get(`EmployeeSizes/getList`,{
      params: filter
    });
  }

  getJobTitlesFilters() {
    const filter: any  = {};
    filter.sort = "sequence ASC";
    return this.httpClient.get(`JobTitles/getList`, {
      params: filter
    });
  }

  getRevenuesFilters() {
    const filter: any  = {};
    filter.sort = "ASC";
    return this.httpClient.get(`Revenues/getList`,{
      params: filter
    });
  }

  getTopicDetailsById(id: any) {
    const filter: any = {};
    return this.httpClient.get("Topics/" + id, {
      params: filter
    });
  }

  getVATDetails(vatId) {
    return this.httpClient.get(`VendorAssessmentTools/${vatId}/details`);
  }

  getVATMarketData(vatId , highlight , filterObject , categoryId , subCatId?: any , skip?: any , limit?: any) {
    const queryParams: any = {};
    queryParams.vatId = vatId;
    queryParams.categoryId = categoryId;
    queryParams.isHighlight = highlight;
    queryParams.access_token = this.myAccessToken.getToken();
    if (skip) {
      queryParams.skip = skip;
    }
    if (subCatId) {
      queryParams.subCategoryId = subCatId;
    }
    if(limit){
      queryParams.limit = limit;
    }
    return this.httpClient.post(`VendorAssessmentTools/market-data/details`, filterObject, {
      params: queryParams
    });
  }

  getVATCategories(vatId) {
    return this.httpClient.get(`VendorAssessmentTools/${vatId}/categories`);
  }

  getVATSubCategory(vatId: string, catId: string) {
    return this.httpClient
    .get(`VendorAssessmentTools/${vatId}/categories/${catId}/sub-category`);
  }

  getMyResearchList(filter: any, userId: string) {
    return this.httpClient.get(`UserAttendedResearchDocuments/my-research`, {
      params: filter
    });
  }

  getSocialFeed(userId: string, filter: object) {
    const params: HttpParams = new HttpParams().set(
      "filter",
      JSON.stringify(filter)
    );
    return this.httpClient.get(`users/${userId}/socialfeed`, {
      params: params
    });
  }

  getSocialFeeds(filter: any) {
    return this.httpClient.get("users/socialfeed", { params: filter });
  }

  getSocialFeedList(filter: any) {
    return this.httpClient.get(`SocialFeeds/feed`, { params: filter });
  }
  getReports(filter: any) {
    return this.httpClient.get("Reports/getList", {
      params: filter
    });
  }

  submitSurveyData(surveyData) {
    return this.httpClient.patch("SurveyResponses", surveyData);
  }

  getMarketDataCategories(researchDocumentId: any) {
    return this.httpClient.get("MarketDataCategories/category-list", { params: { researchDocumentId: researchDocumentId } });
  }

  getMarketDataSubCategory(filter: any) {
    return this.httpClient.get("MarketDataCategories/subcategory-list", { params: filter });
  }

  getReportLink(marketDataId) {
    return this.httpClient.get(`ReportMarketDataMappingViews/marketData/${marketDataId}`);
  }

// covert get to post for master filter
getMarketDat(filter: any, masterfilter?) {
  const params = new HttpParams()
  .set("researchDocumentId",filter.researchDocumentId )
  .append("categoryId", filter.categoryId)
  .append("subCategoryId", filter.subCategoryId)
  .append("isHighlight", filter.isHighlight)
  .append("limit",filter.limit)
  .append("skip", filter.skip);
  let bodyData = masterfilter || {};
  return this.httpClient.post("MarketDataResearchDocuments/market-data-list",bodyData, {
    params: filter
  });
}
  getViewIndex(id:string){
    return this.httpClient.get(`MarketDataCategories/index-list`, {
      params: { researchDocumentId: id}
    });
  }
  bookmark(bookmarkData) {
    return this.httpClient.post("BookMarks/post-bookmark", bookmarkData);
  }

  getBookMarkList(filter: any) {
    return this.httpClient.get("BookMarks/getList", { params: filter });
  }

  getGeographicalResponsibilities(geographyId: string) {
    return this.httpClient.get("Geographies/" + geographyId + "/country");

  }
  getGeographyOfSelectedCountries(){
    return this.httpClient.get(`GeographyCountryMappings`);
  }
  filterMarketData(filterObject: any, researchDocumentId: any) {
     // As suggested by backend
    if(filterObject.countryId){
      if(filterObject.countryId.length !== 0) {
        filterObject.geographyId = [];
       }
    }
    filterObject.researchDocumentId = researchDocumentId;
    return this.httpClient.post(
      "MarketData/create",
      JSON.stringify(filterObject)
    );
  }

  filterVATMarketData(filterObject: any, marketDataId: any) {
    filterObject.marketDataId = marketDataId;
    return this.httpClient.post(
      "MarketData/create",
      JSON.stringify(filterObject)
    );
  }

  getMarketData(marketDataId: string, filter, researchDocumentId?: string) {
    filter.researchDocumentId = researchDocumentId;
    return this.httpClient.get(`MarketData/details/${marketDataId}`, {
      params: filter
    });
  }

  addNickName(data: any, id: string) {
    return this.httpClient.patch(`users/${id}`, data);
  }

  rating(data) {
    return this.httpClient.patch("Ratings", data);
  }

  submitRating(data) {
    return this.httpClient.post("Ratings", data);
  }

  getReportById(id: string, filter) {
    return this.httpClient.get(`Reports/${id}`, { params: filter });
  }

  getTechAnalystPublicProfile(analystId: any) {
    return this.httpClient.get(
      `UserRoleViews/get-analyst-profile/${analystId}`
    );
  }

  getUpcommingReportsList(filter: any) {
    return this.httpClient.get("UpcomingReports/list", { params: filter });
  }

  getTechAnalystUpcommingReportsPublicProfile(filter: any) {
    return this.httpClient.get("UpcomingReports", { params: filter });
  }

  getTechAnalystUpcommingReportList(filter: any) {
    return this.httpClient.get("UpcomingReports/analyst-report", { params: filter });
  }

  getTechAnalystBlogsPublicProfile(analystId: any) {
    return this.httpClient.get(`BlogUserMappings/analyst-blog/${analystId}`);
  }

  getTechAnalystSkillsEndorsementPublicProfile(filter: any, analystId: any) {
    return this.httpClient.get(`Skills/analyst/${analystId}`, {
      params: filter
    });
  }
  

  getTechAnalystFocusAreasEndorsementPublicProfile(filter: any, analystId: any) {
    return this.httpClient.get(`FocusAreas/analyst/${analystId}`, {
      params: filter
    });
  }
  getTechAnalystMarketEndorsementPublicProfile(filter: any, analystId: any) {
    return this.httpClient.get(`Markets/analyst/${analystId}`, {
      params: filter
    });
  }

  getTechAnalystIndustriesEndorsementPublicProfile(filter: any, analystId: any) {
    return this.httpClient.get(`Industries/analyst/${analystId}`, {
      params: filter
    });
  }

  getTechAnalystServiceEndorsementPublicProfile(filter: any, analystId: any) {
    return this.httpClient.get(`Services/analyst/${analystId}`, {
      params: filter
    });
  }
  

  endorseSkill(skillsEndosementId: string) {
    let filter: any = {};
    filter.analystSkillId = skillsEndosementId;
    return this.httpClient.post(
      `Skills/endorse?analystSkillId=${skillsEndosementId}`,
      { params: filter }
    );
  }
  endorseService(serviceEndosementId: string) {
    let filter: any = {};
    filter.analystServiceId = serviceEndosementId;
    return this.httpClient.post(
      `Services/endorse?analystServiceId=${serviceEndosementId}`,
      { params: filter }
    );
  }
  endorseMarket(marketEndosementId: string) {
    let filter: any = {};
    filter.analystMarketId = marketEndosementId;
    return this.httpClient.post(
      `Markets/endorse?analystMarketId=${marketEndosementId}`,
      { params: filter }
    );
  }

  endorseIndustry(industryEndosementId: string) {
    let filter: any = {};
    filter.analystIndustryId = industryEndosementId;
    return this.httpClient.post(
      `Industries/endorse?analystIndustryId=${industryEndosementId}`,
      { params: filter }
    );
  }

  endorseFocusArea(focusAreaEndosementId: string) {
    let filter: any = {};
    filter.analystFocusAreaId = focusAreaEndosementId;
    return this.httpClient.post(
      `FocusAreas/endorse?analystFocusAreaId=${focusAreaEndosementId}`,
      { params: filter }
    );
  }

  

  getAnalystHighlights(filter: any) {
    return this.httpClient.get(`AnalystHighlights/getList`, { params: filter });
  }

  getUserActivities(filter) {
    return this.httpClient.get("UserActivities", { params: filter });
  }

  getTokenPrice() {
    return this.httpClient.get("Tokens");
  }

  placeOrder(body: any, token: any) {
    return this.httpClient.post("Payments/purchase-subscription", body, { params: token });
  }

  purchaseSubscription(body: any, param: any) {
    return this.httpClient.post("Subscriptions/purchase", body, { params: param });
  }

  tokenPurchase(queryData){
    return this.httpClient.post("Payments/purchase-token",null, { params: queryData });
  }

  projectPayment(queryData: any){
    return this.httpClient.post("Payments/project-payment",null, { params: queryData });
  }

  renewSubscription(id: string, tokenObject: any) {
    return this.httpClient.patch(`Subscriptions/renew/${id}`, null, { params: tokenObject });
  }

  getMyConnectionsList(status: any) {
    return this.httpClient.get("ConnectedUsers/connections", { params: status });
  }

  getConnectRequest() {
    return this.httpClient.get("ConnectedUsers/connect-request");
  }

  getUsersInDomain(filter: any) {
    return this.httpClient.get("SubscriptionAllocations/same-email-domain-users", { params: filter })
  }

  setAccessPermission(data: any) {
    return this.httpClient.post("SubscriptionAllocations/set-access-permission", data)
  }

  getTechDomainsListFiltered(filter?: any) {
    return this.httpClient.get("TechDomains", { params: filter });
  }

  getLoyaltyTokens() {
    return this.httpClient.get("users/token-loyalty");
  }

  pointsToTokens() {
    return this.httpClient.post(`TokenTransactionMasters/points-to-tokens`, {});
  }

  imageUploadInS3(userImageBase64: any) {
    let filter: any = {};
    filter.image = userImageBase64;
    return this.httpClient.post("Reports/upload-image", filter);
  }

  s3ImageLinkToProfile(userId: any, profileImageS3URL: any) {
    return this.httpClient.patch(`users/${userId}`, { "profileUrl": profileImageS3URL })
  }

  getProfile(userId: any) {
    return this.httpClient.get(`users/${userId}/profile`)
  }
  getPrivacySettings() {
    return this.httpClient.get(`UserPrivacySettings/privacy-fields`);
  }
  updatePrivacySettings(data) {
    return this.httpClient.post(`UserPrivacies/privacy-setting`, data);
  }
  getPaidReportDetails(reportId) {
    return this.httpClient.get(`Reports/report-price?reportId=${reportId}`);
  }
  getPaidResearchTokenDetails(researchId) {
    return this.httpClient.get(`ResearchDocuments/research-price?researchId=${researchId}`);
  }
  getSynopsisDetails(reportId) {
    return this.httpClient.get(`Reports/synopsis?reportId=${reportId}`)
  }
  purchaseReport(reportId) {
    return this.httpClient.post(`Reports/purchase-report?reportId=${reportId}`, {})
  }
  purchaseResearch(researchId) {
    return this.httpClient.post(`ResearchDocuments/purchase-research?researchId=${researchId}`, {})
  }
  deleteUserFromSubscription(id) {
    return this.httpClient.delete(`SubscriptionAllocations/${id}`);
  }
  deleteReportGraphLinkMapping(id) {
    return this.httpClient.delete(`ReportMarketDataMappings/${id}`);
  }

  /**
   * @description state management for payment completed
   */
    setPaymentSate(state:boolean){
      this.isPaymentCompleted = state;
    }
    getPaymentState():boolean{
      return this.isPaymentCompleted;
    }
    getSolutionFilter(query){
      let filter = new HttpParams().set("filter", JSON.stringify(query));
      // if (query.techDomainId) {
      //   filter = filter.append("techDomainId", (query.techDomainId));
      // }
    return this.httpClient.get("SubTechDomains/sub-tech-domain", { params: query });
    }

    getWholeAboutUs() {
      return this.httpClient.get(`ContentManagements/about-us`)
    }
    masterSearch(query) {
      let url = `MasterSearchViews/content?limit=${query.limit}&skip=${query.skip}`;
      if (query.type !== "") {
        url = `${url}&type=[${query.type}]`;
      }
      else {
        url = `${url}&type=[]`;
      }
      if(query.search !== "") {
        url = `${url}&search=${query.search}`;
      }
      else {
        url = `${url}&search=""`;
      }
      return this.httpClient.get(url);

    }

    // updateMasterFilterData() {

    // }
    updateMasterSearchData(searchResponse, existingResponseData?) {
      if (!existingResponseData) {
        this.globalSearchResponse.next(searchResponse.data);
      } else {
        const newSetOfData = [...existingResponseData, ...searchResponse.data];
        this.globalSearchResponse.next(newSetOfData);
      }
    }
    updateMasterSearchQueryFilters(filter) {
      this.masterSearchFilter.next(filter);
    }
    getCustomerDeatils(type) {
      const params = new HttpParams().set("type", type);
      return this.httpClient.get(`ContentManagements/about-us/content`, { params: params })
    }
    getResearchDocumentList(filters) {
      let filter = new HttpParams().set("filter", JSON.stringify(filters));
      return this.httpClient.get("MarketDataResearchCategoryViews", { params: filter });
    }
    getIndividualMarketDataResults(id) {
      return this.httpClient.get(`MarketData/${id}`)
    }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/roles-shared.service.ts